import { render, staticRenderFns } from "./IconSvgQAScholarship.vue?vue&type=template&id=17293aa2&scoped=true&"
import script from "./IconSvgQAScholarship.vue?vue&type=script&lang=js&"
export * from "./IconSvgQAScholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17293aa2",
  null
  
)

export default component.exports